/**
 * SN-4709 Balance tab gate (D25 as amended by D32).
 *
 * TENANT-BLIND BY SIGNATURE: this predicate must never accept or inspect tenant
 * identity (isCanlan / customer name) — exposure is the team + the probe result
 * only. The server's manageBalance policy is the authority; a 403 or an empty
 * registration list already resolved to [] upstream.
 */

export interface BalanceGateTeam {
  id?: string
  is_placeholder?: boolean
}

export const shouldShowBalanceTab = (
  item: BalanceGateTeam | null | undefined,
  registrations: readonly unknown[] | null | undefined
): boolean => {
  if (!item || item.is_placeholder === true) {
    return false
  }

  return Array.isArray(registrations) && registrations.length > 0
}
